import React, { useEffect } from "react";
import { observer } from "mobx-react-lite";
import { Link } from "react-router-dom";

import LoadingComponent from "../../app/layout/LoadingComponent";
import { getCATCursos } from '../../app/models/CATCursos';
import { Botonera } from '../Portafolio/helpers/botonera';
import { useStore } from "../../app/stores/store";

import { AnchorTabsPosgrados } from "../Portafolio/Handlers/AnchorTabs";
import { BuscadorComponent } from "../Portafolio/BuscadorCursos/BuscadorComponent";
import { calculoFechas } from "../Portafolio/helpers/calculoFechas";

import banner from "../../images/maestrias_doctorados.png";
import Footer from "../Footer";

import icon_person from '../Portafolio/src/imgs/person_icon.svg';
import icon_teacher from '../Portafolio/src/imgs/teacher_icon.svg';
import icon_calendar from '../Portafolio/src/imgs/calendar_icon.svg';
import { RegionalBannerPeten } from "../Portafolio/Handlers/RegionalBannerPeten";
import { AnchorTabsCategories } from "../Portafolio/Handlers/AnchorTabsCategories";

export default observer(function Cursos() {

  const { userStore: { user, logout, isLoggedIn } } = useStore();
  const { CATCursosStore } = useStore();
  const { loadCATCursosByDir, CATCursosRegistry, getCATCursosByCodigo, loadCATCursosByLevel } = CATCursosStore;

  useEffect(() => {
    if (CATCursosRegistry.size <= 1) {
      loadCATCursosByLevel("177", "1");
      loadCATCursosByLevel("188", "1");
    }
  }, [CATCursosRegistry.size, loadCATCursosByLevel]);

  if (CATCursosStore.loadingInitial)

    return <LoadingComponent content="Cargando datos.." />;
  return (
    <>

      <RegionalBannerPeten />

      {/* <div className="banner_area container-fluid">
        <div className="banner_top">
          <img src={banner}></img>
        </div>
      </div> */}

      < AnchorTabsPosgrados />
      < AnchorTabsCategories />

      <div className="portafolio_phome_area catalogo_servicios">

        <div className="portafolio_header">
        <Botonera/>
          <div className="buscador_area">
            <BuscadorComponent />
          </div>
        </div>

        <div id="hw_search" className="portafolio_htexto">
          <p>En alianza y coordinación con el ICAP, INAP ofrece educación científica y académica de alto nivel a profesionales del sector público y privado que están involucrados en la toma de decisiones dentro de la Administración Pública. Sus programas están orientados a proporcionar herramientas para que el funcionario público pueda incidir en la reforma del Estado y en la transformación y modernización de la Administración Pública. </p>
        </div>

        <div id="section1" className="portafolio_subcat first_section">
          <h2>Maestrías</h2>
        </div>


        <div id="hw_search" className="portafolio_content">

          {CATCursosStore.getCATCursosByLevel.map((item: getCATCursos) => {

            const url = `/asesoria/${item.id}/${user?.id}`,
                  startDateFrom = new Date( item.editions[0]?.fechaDeInicioInscripcion );

            if (
              item.nivel == "177" && item.editions[0]?.is_active === true
            ) {
              return (

                <>

                  <div className="portafolio_card">

                    <Link to={url}>

                      <div className="pcard_imagen"> <img src={item.imageUrl} alt={item.nombre} /></div>
                      <div className="pcard_tipoc"> <p className="mod_card_basica">{item.modalidad}</p></div>

                      <div className="pcard_contenido_publico">
                        <div className="pcard_edicion">
                          <p>-Edición en curso {item.editions[0]?.numeroEdicion}</p>
                        </div>

                        <div className="pcard_titulo_curso">
                          <p className='titulo_curso' id='titulo_curso'>{item.nombre}</p>
                        </div>

                        <div className="card_info_curso">
                          <div className="pcard_estudiantes corto_para_fecha">
                            <img src={icon_person} />
                            <p>{item.editions[0]?.cupoActual} Inscritos</p>
                          </div>
                          <div className="pcard_fecha">
                            <img src={icon_calendar} />
                            <p> Consultar Fecha </p>
                          </div>
                        </div>

                        <div className="pcard_docentes">
                          <img src={icon_teacher} />
                          <p>Lic. {item.editions[0]?.catedratico}</p>
                        </div>

                      </div>

                      <div className="pcard_linea"><span></span></div>

                    </Link>

                  </div>

                </>


              );
            }
          })}

        </div>


        <div id="section2" className="portafolio_subcat second_section">
          <h2>Doctorado</h2>
        </div>

        <div id="hw_search" className="portafolio_content">

          {CATCursosStore.getCATCursosByLevel.map((item: getCATCursos) => {

            const url = `/asesoria/${item.id}/${user?.id}`,
                  startDateFrom = new Date( item.editions[0]?.fechaDeInicioInscripcion );

            if (
              item.nivel == "188" && item.editions[0]?.is_active === true
            ) {
              return (

                <>

                  <div className="portafolio_card">

                    <Link to={url}>

                      <div className="pcard_imagen"> <img src={item.imageUrl} alt={item.nombre} /></div>
                      <div className="pcard_tipoc"> <p className="mod_card_intermedia">{item.modalidad}</p></div>

                      <div className="pcard_contenido_publico">
                        <div className="pcard_edicion">
                          <p>-Edición en curso {item.editions[0]?.numeroEdicion}</p>
                        </div>

                        <div className="pcard_titulo_curso">
                          <p className='titulo_curso' id='titulo_curso'>{item.nombre}</p>
                        </div>

                        <div className="card_info_curso">
                          <div className="pcard_estudiantes corto_para_fecha">
                            <img src={icon_person} />
                            <p>{item.editions[0]?.cupoActual} Inscritos</p>
                          </div>
                          <div className="pcard_fecha">
                            <img src={icon_calendar} />
                            <p> Consultar Fecha </p>
                          </div>
                        </div>

                        <div className="pcard_docentes">
                          <img src={icon_teacher} />
                          <p>Lic. {item.editions[0]?.catedratico}</p>
                        </div>

                      </div>

                      <div className="pcard_linea"><span></span></div>

                    </Link>

                  </div>

                </>


              );
            }
          })}

        </div>

      </div>

      <Footer />

    </>

  );
});
